import { NgModule } from '@angular/core';
import { AppRoutingModule } from '@app/app.routing';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponentModule } from '@app/root/app.component.module';
import { SocialLoginModule } from '@abacritt/angularx-social-login';

@NgModule({
  imports: [
    AppComponentModule,
    CommonModule,
    SocialLoginModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgxWebstorageModule.forRoot(),
    HttpClientModule,
    ToastrModule.forRoot({ preventDuplicates: true }),
  ],
  exports: [],
  providers: [],
})
export class SharedMainModule {}
